import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { BottomNav } from "./BottomNav";
import { InactivityLogout } from "./InactivityLogout";

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <InactivityLogout />
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <main className="lg:ml-64 pb-20 lg:pb-8">
        <Outlet />
      </main>
      
      <BottomNav onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
    </div>
  );
}
